import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-tabitpay-check-dialog',
    templateUrl: './tabitpay-check-dialog.component.html',
    styleUrls: ['./tabitpay-check-dialog.component.scss'],
    standalone: false
})
export class TabitpayCheckDialogComponent {

	constructor(
		public dialogRef: MatDialogRef<TabitpayCheckDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public appService: AppService,
	) { }


	cancel() {
		this.dialogRef.close();
	}

	apply(mode) {
		this.dialogRef.close(mode);
	}

}
